import React from 'react';
import { motion } from 'framer-motion';
import { FiBriefcase } from 'react-icons/fi';
import SectionHeader from './SectionHeader';

const fadeUp = {
  hidden: { opacity: 0, y: 32 },
  visible: { opacity: 1, y: 0 },
};

const ExperienceSection = ({ content }) => (
  <section id="experience" className="section section-dark">
    <div className="container section-stack">
      <SectionHeader
        eyebrow={content.eyebrow}
        title={content.title}
        intro={content.intro}
      />

      <div className="snapshot-grid">
        {content.items.map((item, index) => (
          <motion.article
            key={item.label}
            className="snapshot-card"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
            variants={fadeUp}
            transition={{ duration: 0.5, delay: index * 0.08 }}
          >
            <div className="snapshot-icon">
              <FiBriefcase />
            </div>
            <h3>{item.label}</h3>
            <p>{item.text}</p>
          </motion.article>
        ))}
      </div>
    </div>
  </section>
);

export default ExperienceSection;
